import { render, staticRenderFns } from "./TabForm.vue?vue&type=template&id=3ff4ee28&scoped=true&"
import script from "./TabForm.vue?vue&type=script&lang=js&"
export * from "./TabForm.vue?vue&type=script&lang=js&"
import style0 from "./TabForm.vue?vue&type=style&index=0&id=3ff4ee28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4ee28",
  null
  
)

export default component.exports